import turfFunc from "@turf/line-split";

export default function lineSplit(feature1, feature2) {
    return turfFunc(feature1, feature2);
};
